<template>
  <v-list-group v-if="!appNavigation?.isItemHidden(route) && isRoutePermitted">
    <template #activator="{ props: activatorProps, isOpen }">
      <app-navigation-item
        :activator-props
        :append-icon="appNavigation?.getIconsFromRoute(route).appendIcon"
        :icon="appNavigation?.getIconsFromRoute(route).icon"
        :is-open
        :route="{ ...route, name: undefined }"
      />
    </template>
    <template v-for="childRoute in route.children" :key="childRoute.path">
      <app-navigation-item
        v-if="!childRoute.children || childRoute.children.every((child) => appNavigation?.isItemHidden(child))"
        :route="childRoute"
      />
      <app-navigation-list-group v-else :route="childRoute" />
    </template>
  </v-list-group>
</template>

<script lang="ts" setup>
import { type RouteRecordRaw } from 'vue-router';

import { injectAppNavigationOrThrow } from './AppNavigation.context';
import AppNavigationItem from './AppNavigationItem.vue';

interface Props {
  route: RouteRecordRaw;
}

const { route } = defineProps<Props>();

const appNavigation = injectAppNavigationOrThrow();

const isRoutePermitted = appNavigation.isRoutePermitted(() => route.meta);
</script>

<style lang="postcss" scoped>
:deep(.v-list-group__items .v-list-item) {
    padding-inline-start: calc(-4px + var(--indent-padding)) !important;
}
</style>
